export const filterUndefined = <T>(value: T | undefined | null): value is T => value != null;

export function iife<T>(f: () => T): T {
  return f();
}
